
import { Component, OnInit, Input, inject } from '@angular/core';
import { SortedTableClass, SortedFilteredList, StoreLoader, combineToList, IList, TableRowEmptyComponent, ListPagingComponent, LoaderSpinnerComponent } from '@aston/foundation';
import { Store } from '@ngrx/store';
import { tap, takeUntil } from 'rxjs/operators';
import { ListActionHandler } from 'apps/middle/src/app/shared-module/handlers';
import { AsyncPipe, NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { importColumnMapping } from '../../functions';
import { IImportFileReportErrorLineItem, IImportErrorColumnRowModel, IImportItem, IImportReportActions, IImportReportSelectors } from '../../models';
import { ImportInstanceDetailCode, ImportReportErrorLinesListSortProp, ImportType } from '../../enums';

type ImportReportErrorLinesSortedList = SortedFilteredList<IImportFileReportErrorLineItem, ImportReportErrorLinesListSortProp>;

@Component({
	selector: 'import-report-errors-list-table-lines',
	templateUrl: './import-report-errors-list-table-lines.component.html',
	imports: [AsyncPipe, TranslateModule, TableRowEmptyComponent, LoaderSpinnerComponent, ListPagingComponent, NgClass]
})
export class ImportReportErrorsListTableLineComponent extends SortedTableClass<IImportFileReportErrorLineItem, ImportReportErrorLinesListSortProp> implements OnInit {
	private store = inject(Store);

	@Input() reportErrorColumn: IImportErrorColumnRowModel;
	@Input() columnName: string;
	@Input() currentImport: IImportItem;
	@Input() actions: IImportReportActions;
	@Input() selectors: IImportReportSelectors;

	listHandler: ListActionHandler;

	ImportType = ImportType;
	sortCols = ImportReportErrorLinesListSortProp;
	errorCodes = ImportInstanceDetailCode;

	loader = StoreLoader.empty();

	dispatchPagingAction(paging) {
		this.store.dispatch(this.actions.UpdateLinesSettings({
			column: this.reportErrorColumn, paging
		}));
	}

	ngOnInit() {
		this.loader = new StoreLoader(
			this.selectors.selectLinesListIsLoading(this.reportErrorColumn),
			this.selectors.selectLinesListError(this.reportErrorColumn)
		);

		this.listHandler = new ListActionHandler()
			.withPagingDispatcher(this.dispatchPagingAction.bind(this));

		combineToList<IList<IImportFileReportErrorLineItem>, IImportFileReportErrorLineItem, ImportReportErrorLinesListSortProp>(
			this.selectors.selectLinesList(this.reportErrorColumn),
			this.selectors.selectLinesListState(this.reportErrorColumn),
		).pipe(
			tap((sortedList: ImportReportErrorLinesSortedList) => this.list = sortedList),
			takeUntil(this.destroySubscriptions$)
		).subscribe();
	}

	columnMapping(column: string): string {
		return importColumnMapping(column, this.currentImport.columnsMapping);
	}
}
